import React, { useEffect, useState } from "react";
import { UserAnalytics } from "../../components/analyticsTable/userAnalytics";
import DefaultHeading from '../../components/heading/DefaultHeading';
import { eventEnum, logEvent } from "../../services/eventsService/eventService";
import { OrderAnalytics } from "../../features/orderAnalytics/orderAnalytics";
import './userAnalytics.css'
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { getMetaDataConfig } from "../../services/uiConfigService";
import { configurationAttributeType } from "../../types";
import { Loader } from "../../components/loader/Loader";
export function Analytics() {
    const { translate } = usePortalTranslation();
    const [coeAPI, setCoeAPI] = useState<Boolean>(false);
    const [coeAPIEnabled, setCoeAPiEnabled] = useState<Boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    useEffect(() => {
        logEvent(eventEnum.live_dashboard, { feature_name: "Analytics" })
        const fetchPortalConfig = async () => {
            try {
                setLoading(true);
                const portalConfig = await getMetaDataConfig("clientConfig", "portal_configuration");
                const portal_config: configurationAttributeType[] = portalConfig?.domainValues ?? [];
                const coeAPI = portal_config?.find((item) => item.name === "coeAPI")?.value ?? false;
                setCoeAPI(coeAPI);
            } catch (error) {
                console.error("Error fetching portal config:", error);
            } finally {
                setLoading(false); 
            }
        };

        fetchPortalConfig();
    }, [])
     if (loading) {
    return <Loader />;
  }
    return (
        <div className="box-container">
            <div className="tile-container">
                <DefaultHeading heading= {translate(TranslationEnum.analytics,"User Analytics")} />
                <UserAnalytics />
                <DefaultHeading heading={translate(TranslationEnum.analytics,"Order Analytics")} />
                <OrderAnalytics coeAPI={coeAPI} type={"eb2b"}/>
            </div>
        </div>
    );
}